import useCart from 'modules/cart/util/use-cart';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import Column from 'shared/components/column';
import Pressable from 'shared/components/pressable';
import Row from 'shared/components/row';
import {SemiBoldText} from 'shared/components/text';
import styled from 'styled-components';

const CartHeader: React.FC = () => {
  const {companyQuery} = useCart();
  const navigate = useNavigate();

  const handleAddMoreProducts = () =>
    navigate(`${companyQuery.data?.id}/products`);

  return (
    <Column gap={15}>
      <Row gap={10}>
        <Logo src={companyQuery.data?.logo} />
        <Column>
          <SemiBoldText>{companyQuery.data?.name}</SemiBoldText>
          <Pressable
            style={{alignSelf: 'flex-start'}}
            onClick={handleAddMoreProducts}>
            <SemiBoldText size="small" color="primary">
              Adicionar produtos
            </SemiBoldText>
          </Pressable>
        </Column>
      </Row>
      <Line />
    </Column>
  );
};

export default CartHeader;

export const Logo = styled.img({
  width: 40,
  height: 40,
  objectFit: 'cover',
  borderRadius: 35,
});

export const Line = styled.div({
  height: 1,
  width: '100%',
  backgroundColor: 'rgba(128, 128, 128, .6)',
});
